import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './UserForm.scss';
import EmailField from '../_molecules/EmailField/EmailField';
import { getFieldInitialState } from '../../utils/helpers';


import { TEXT_FIELD_STATUS, CONTEXT_PROVIDERS, LOADING, SUCCESS, INIT, ERROR } from '../../utils/constants';
import UserFormContext from './UserFormContext';
import URLTextField from '../_molecules/URLTextField/URLTextField';
import TimeZonePicker from '../_molecules/TimeZonePicker/TimeZonePicker';
import ConnectedTextField from '../_atomic/ConnectedTextField/ConnectedTextField';
import FullNameField from '../_molecules/FullNameField/FullNameField';
import Button from '../_atomic/Button/Button';
import ErrorModal from '../_molecules/ErrorModal/ErrorModal';
import CustomMultiSelectAdmin from '../_molecules/CustomMultiSelectAdmin/CustomMultiSelectAdmin';
import ArrowButton from '../_atomic/ArrowButton/ArrowButton';


const userEmailFieldName = 'email';
const timeZoneFieldName = 'timezone';
const fullNameFieldName = 'fullName';
const companyNameFieldName = 'company';
const positionFieldName = 'position';
const roleField = 'role';
const companyWebsiteFieldName = 'website';


class UserForm extends Component {
  static propTypes = {
    profile: PropTypes.shape({}).isRequired,
    id: PropTypes.number.isRequired,
    email: PropTypes.string.isRequired,
    submitHandler: PropTypes.func.isRequired,
    updateProfileStatus: PropTypes.string.isRequired,
    updateProfileError: PropTypes.string.isRequired,
    emailSubscriptions: PropTypes.func.isRequired,
    isAdminUserScreen: PropTypes.bool,
    navigateToApps: PropTypes.func,
    patchUserPrivilege: PropTypes.func.isRequired,
    patchUserDemotePrivilege: PropTypes.func.isRequired,
    getAdminProfile: PropTypes.func.isRequired,
    sidebarStatus: PropTypes.bool,
  };
  static defaultProps = {
    isAdminUserScreen: false,
    sidebarStatus: true,
    navigateToApps: () => {},
  }
  constructor() {
    super();
    this.fields = {};
  }

  state = {
    formStatus: TEXT_FIELD_STATUS.VALID,
    fields: {
      [userEmailFieldName]: getFieldInitialState(),
      [timeZoneFieldName]: getFieldInitialState(),
      [fullNameFieldName]: getFieldInitialState(),
      [positionFieldName]: getFieldInitialState(),
      [roleField]: getFieldInitialState(),
      [companyWebsiteFieldName]: getFieldInitialState(),
      [companyNameFieldName]: getFieldInitialState(),
    },
    loadingViewState: INIT,
  };
  componentWillMount() {
    const { profile, id, email } = this.props;
    if (id) {
      const fields = this.fillFields(profile, id, email);
      this.setState(() => ({
        fields,
      }));
    }
  }

  componentDidUpdate(prevProps) {
    const {
      profile, id, email, updateProfileStatus,
    } = this.props;
    if (prevProps.id !== id) {
      const fields = this.fillFields(profile, id, email);
      this.setState(() => ({
        fields,
      }));
    }
    if (prevProps.profile.role !== profile.role) {
      const fields = this.fillFields(profile, id, email);
      this.setState(() => ({
        fields,
      }));
    }
    if (prevProps.updateProfileStatus !== updateProfileStatus) {
      if (updateProfileStatus === SUCCESS && this.state.loadingViewState === SUCCESS) {
        this.hideCompleteView();
      }
    }
  }

  getFormStatus = (fields) => {
    let status = TEXT_FIELD_STATUS.INITIAL;
    let validFields = 1;
    let invalidFields = 0;
    const fieldsNames = Object.keys(fields);
    /* calc invalid fields coz form can have one VALID and one INITIAL field
       then form isn't valid or invalid it is initial */

    fieldsNames.forEach((name) => {
      if (fields[name].status === TEXT_FIELD_STATUS.VALID) validFields += 1;
      if (fields[name].status === TEXT_FIELD_STATUS.INVALID) {
        invalidFields += 1;
      }
    });
    if (validFields === fieldsNames.length) {
      status = TEXT_FIELD_STATUS.VALID;
    }

    if (invalidFields > 0) {
      status = TEXT_FIELD_STATUS.INVALID;
    }
    return status;
  };

  loadCompleteView = (timerDelay = 800) => {
    setTimeout(() => {
      this.setState(() => ({
        loadingViewState: SUCCESS,

      }), this.hideCompleteView);
    }, timerDelay);
  }

  hideCompleteView = (timerDelay = 700) => {
    if (this.props.updateProfileStatus === SUCCESS && this.state.loadingViewState === SUCCESS) {
      setTimeout(() => {
        this.setState(() => ({
          loadingViewState: INIT,
        }));
      }, timerDelay);
    }
  }
  fillFields = (profile, id, email) => {
    const fields = { ...this.state.fields };
    fields[userEmailFieldName].value = email;
    fields[fullNameFieldName].value = profile.fullName;
    fields[companyNameFieldName].value = profile.company;
    fields[positionFieldName].value = profile.position;
    fields[roleField].value = profile.role;
    fields[companyWebsiteFieldName].value = profile.website;
    fields[timeZoneFieldName].value = profile.timezone;

    fields[userEmailFieldName].status = TEXT_FIELD_STATUS.VALID;
    fields[fullNameFieldName].status = TEXT_FIELD_STATUS.VALID;
    fields[companyNameFieldName].status = TEXT_FIELD_STATUS.VALID;
    fields[positionFieldName].status = TEXT_FIELD_STATUS.VALID;
    fields[companyWebsiteFieldName].status = TEXT_FIELD_STATUS.VALID;
    fields[timeZoneFieldName].status = TEXT_FIELD_STATUS.VALID;

    return fields;
  }

  fieldChangeHandler = ({ name, value }) => {
    const fields = { ...this.state.fields };
    let { formStatus } = this.state;
    fields[name].value = value;
    if (fields[name].status !== TEXT_FIELD_STATUS.INITIAL || name === timeZoneFieldName) {
      const { validator } = this.fields[name];
      const validate = validator(fields[name].value);
      fields[name].status = validate.status;
      fields[name].errorText = validate.errorText;
      formStatus = this.getFormStatus(fields);
    }
    this.setState(() => ({ fields, formStatus }));
  };

  fieldFocusHandler = ({ name, isFocused, value }) => {
    const fields = { ...this.state.fields };
    let { formStatus } = this.state;
    fields[name].isFocused = isFocused;
    fields[name].value = value;
    if (!isFocused) {
      const { validator } = this.fields[name];
      const validate = validator(fields[name].value);
      fields[name].status = validate.status;
      fields[name].errorText = validate.errorText;
      formStatus = this.getFormStatus(fields);
    }
    this.setState(() => ({ fields, formStatus }));
  };

  registerField = ({ name, validator }) => {
    this.fields[name] = {
      validator,
    };
  }

  submitHandler = (e) => {
    e.preventDefault();
    const fields = { ...this.state.fields };
    Object.keys(this.fields).forEach((name) => {
      const { validator } = this.fields[name];
      const validate = validator(fields[name].value);
      fields[name].status = validate.status;
      fields[name].errorText = validate.errorText;
    });
    const formStatus = this.getFormStatus(fields);
    this.setState(
      () => ({
        fields,
        formStatus,
      }),
      () => {
        if (formStatus === TEXT_FIELD_STATUS.VALID) {
          const data = {};
          const { emailSubscriptions } = this.props;
          Object.keys(fields).forEach((fieldName) => {
            if (fieldName !== userEmailFieldName) {
              data[fieldName] = fields[fieldName].value;
            }
          });
          data.finance = emailSubscriptions.finance;
          data.news = emailSubscriptions.news;
          this.props.submitHandler(data);
          this.setState(() => ({
            loadingViewState: LOADING,
          }));
          this.loadCompleteView();
        }
      },
    );
  };
  navigateToBack = () => {
    window.history.back();
  }
  render() {
    const {
      fields, formStatus, loadingViewState, updateProfileStatus,
    } = this.state;
    const { patchUserPrivilege, patchUserDemotePrivilege, sidebarStatus } = this.props;
    const { updateProfileError, isAdminUserScreen, navigateToApps } = this.props;
    const userEmailField = fields[userEmailFieldName];
    const fullNameField = fields[fullNameFieldName];
    const timeZoneField = fields[timeZoneFieldName];
    const companyNameField = fields[companyNameFieldName];
    const positionField = fields[positionFieldName];
    const role = fields[roleField];
    const websiteField = fields[companyWebsiteFieldName];
    const disabledButton = formStatus === TEXT_FIELD_STATUS.INVALID;
    const isViewLoading = loadingViewState === LOADING;
    const isViewSuccess = loadingViewState === SUCCESS;
    const isError = updateProfileStatus === ERROR;
    const privilegeValues = role.value === 'ADMIN' ? [{ label: 'Downgrade to user', value: this.props.id }] : [{ label: 'Upgrade to admin', value: this.props.id }];
    const userSelectRole = role.value === 'ADMIN';
    const buttonWrapperClassnames = classNames({
      'button-wrapper': true,
      'is-loading': isViewLoading,
      'is-success': isViewSuccess,
    });
    const buttonLoaderClassnames = classNames({
      'button-loader': true,
      'load-complete': isViewSuccess,
      visible: loadingViewState !== INIT,
    });

    return (
      <form onSubmit={this.submitHandler} className="user-form">
        <ErrorModal visible={isError} error={updateProfileError} />
        <ArrowButton onClick={this.navigateToBack} padLeft={sidebarStatus ? 125 : 125} />
        <UserFormContext.Provider
          value={{
            register: this.registerField,
            changeHandler: this.fieldChangeHandler,
            focusHandler: this.fieldFocusHandler,
          }}
        >
          <EmailField
            name={userEmailFieldName}
            value={userEmailField.value}
            status={userEmailField.status}
            disabled
            isFocused={userEmailField.isFocused}
            errorText={userEmailField.errorText}
            isRequired
            contextProvider={CONTEXT_PROVIDERS.UserFormContext}
          />
          <FullNameField
            value={fullNameField.value}
            status={fullNameField.status}
            isFocused={fullNameField.isFocused}
            errorText={fullNameField.errorText}
            hint={fullNameField.hint}
            isRequired
            disabled={isAdminUserScreen}
            name={fullNameFieldName}
            contextProvider={CONTEXT_PROVIDERS.UserFormContext}
          />
          {!userSelectRole &&
          <ConnectedTextField
            value={companyNameField.value}
            status={companyNameField.status}
            isFocused={companyNameField.isFocused}
            errorText={companyNameField.errorText}
            hint={companyNameField.hint}
            isRequired
            label="Company Name"
            placeholder="Company Name"
            name={companyNameFieldName}
            errorSign
            disabled={isAdminUserScreen}
            contextProvider={CONTEXT_PROVIDERS.UserFormContext}
          />
          }
          <ConnectedTextField
            value={positionField.value}
            status={positionField.status}
            isFocused={positionField.isFocused}
            errorText={positionField.errorText}
            hint={positionField.hint}
            isRequired
            errorSign
            disabled={isAdminUserScreen}
            label="Position"
            placeholder="Position"
            name={positionFieldName}
            contextProvider={CONTEXT_PROVIDERS.UserFormContext}
          />
          {!userSelectRole &&
          <URLTextField
            value={websiteField.value}
            status={websiteField.status}
            isFocused={websiteField.isFocused}
            errorText={websiteField.errorText}
            hint={websiteField.hint}
            isRequired
            disabled={isAdminUserScreen}
            name={companyWebsiteFieldName}
            contextProvider={CONTEXT_PROVIDERS.UserFormContext}
          />
          }
          <TimeZonePicker
            isRequired
            registerField={this.registerField}
            status={timeZoneField.status}
            value={timeZoneField.value}
            name={timeZoneFieldName}
            errorText={timeZoneField.errorText}
            disabled={isAdminUserScreen}
            inputProps={{
              placeholder: 'Timezone',
            }}
            onChange={this.fieldChangeHandler}
          />
          {!userSelectRole &&
          <CustomMultiSelectAdmin
            closeOnSelect
            values={privilegeValues}
            value={role.value}
            placeholder={role.value}
            label="Role"
            enabled={isAdminUserScreen}
            focusHandler={() => {}}
            searchable={false}
            multi={false}
            disabled={isAdminUserScreen !== true}
            patchUserPrivilege={patchUserPrivilege}
            patchUserDemotePrivilege={patchUserDemotePrivilege}
            getAdminProfile={this.props.getAdminProfile}
          />
          }
        </UserFormContext.Provider>
        {isAdminUserScreen ?
          <div className="button-wrapper">
            {!userSelectRole &&
            <Button label="Apps of This Client" clickHandler={role.value === 'ADMIN' ? null : navigateToApps} disabled={role.value === 'ADMIN'} />
            }
          </div>
        :
          <div className={buttonWrapperClassnames}>
            <Button disabled={disabledButton} label={loadingViewState !== INIT ? ' ' : 'Save'} type="submit" />
            <div className={buttonLoaderClassnames}>
              <div className="checkmark draw" />
            </div>
          </div> }
      </form>
    );
  }
}

export default UserForm;

// start timer together with animation and check toggl checkout together, then reset store to init;



// WEBPACK FOOTER //
// ./src/components/UserForm/UserForm.js